/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, now: NonNullable<unknown>, before: NonNullable<unknown> }} Progress_Report_Distribution_RowInputs */

const en_us2_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.now} now, ${i?.before} before`)
};

const pt_br2_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.now} agora, ${i?.before} antes`)
};

const es_419_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.now} ahora, ${i?.before} antes`)
};

const pt_pt2_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.now} agora, ${i?.before} antes`)
};

const fr_fr2_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} : ${i?.now} maintenant, ${i?.before} avant`)
};

const de_de2_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.now} jetzt, ${i?.before} vorher`)
};

const it_it2_progress_report_distribution_row = /** @type {(inputs: Progress_Report_Distribution_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle}: ${i?.now} ora, ${i?.before} prima`)
};

/**
* | output |
* | --- |
* | "{muscle}: {now} now, {before} before" |
*
* @param {Progress_Report_Distribution_RowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_distribution_row = /** @type {((inputs: Progress_Report_Distribution_RowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Distribution_RowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_distribution_row(inputs)
	if (locale === "es-419") return es_419_progress_report_distribution_row(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_distribution_row(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_distribution_row(inputs)
	if (locale === "de-DE") return de_de2_progress_report_distribution_row(inputs)
	if (locale === "it-IT") return it_it2_progress_report_distribution_row(inputs)
	return en_us2_progress_report_distribution_row(inputs)
});
export { progress_report_distribution_row as "progress-report.distribution_row" }